"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageRequest = void 0;
class ImageRequest {
}
exports.ImageRequest = ImageRequest;
//# sourceMappingURL=ImageRequest.js.map